import bakeryAuthService from '@/services/mock/bakery-auth-service/bakeryAuthService';

export default {
  sendEmailToGetMagicToken: async ({ commit }, { mail, callbackURL }) => {
    const res = await bakeryAuthService.bakeryAuth(mail, callbackURL);
    commit('SET_BAKERY', res);
  },
};
